// Crear archivo: /Users/admin/Desktop/plataformas/radar-ia/client/src/Secciones/ResetPassword.js

import React, { useState, useEffect } from 'react';
//import { useNavigate, useSearchParams } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEyeSlash, faEye } from '@fortawesome/free-solid-svg-icons';

import './Login.css';
import { validatePassword, MIN_LENGTH_STANDARD, REQUIRED_CHAR_TYPES } from '../utils/passwordPolicy';
import * as Img from '../Components/Imagenes';
import imgLogoMirc from '../user/logo_mirc.svg';
import imgLogoFemsa from '../user/logo_femsa.svg';

//para que reciba  props:
const ResetPassword = ({ token, onBack }) => {


	const [showPassword, setShowPassword] = useState(false);
	const [showConfirmPassword, setShowConfirmPassword] = useState(false);


	//const [searchParams] = useSearchParams();
	//const navigate = useNavigate();
	//const token = searchParams.get('token');

	const [formData, setFormData] = useState({
		password: '',
		confirmPassword: ''
	});
	const [message, setMessage] = useState('');
	const [error, setError] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const [tokenValid, setTokenValid] = useState(false);
	const [userEmail, setUserEmail] = useState('');

	// Validar contraseña contra la norma FEMSA (ver utils/passwordPolicy.js).
	// La recuperación siempre es de una cuenta estándar desde el portal público.
	const checkPassword = (password) => validatePassword(password, 'user');

	// Verificar token al cargar
	useEffect(() => {
		const verifyToken = async () => {
			if (!token) {
				setError('Token de recuperación no válido');
				return;
			}

			try {
				const API_BASE = process.env.REACT_APP_API_BASE;
				const response = await fetch(`${API_BASE}/verify-reset-token/${token}`);

				if (response.ok) {
					const data = await response.json();
					setTokenValid(true);
					setUserEmail(data.email);
				} else {
					setError('El enlace de recuperación ha expirado o no es válido');
				}
			} catch (error) {
				setError('Error de conexión. Intenta más tarde.');
			}
		};

		verifyToken();
	}, [token]);

	const handleSubmit = async (e) => {
		e.preventDefault();
		setError('');
		setMessage('');
		setIsLoading(true);

		if (!formData.password || !formData.confirmPassword) {
			setError('Todos los campos son obligatorios');
			setIsLoading(false);
			return;
		}

		if (!checkPassword(formData.password).isValid) {
			setError('La contraseña no cumple con los requisitos');
			setIsLoading(false);
			return;
		}

		if (formData.password !== formData.confirmPassword) {
			setError('Las contraseñas no coinciden');
			setIsLoading(false);
			return;
		}

		try {
			const API_BASE = process.env.REACT_APP_API_BASE;
			const response = await fetch(`${API_BASE}/reset-password`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					token,
					newPassword: formData.password
				})
			});

			if (response.ok) {
				setMessage('Contraseña actualizada exitosamente. Redirigiendo...');
				/* setTimeout(() => {
					navigate('/');
				}, 2000); */

				// Limpiar la URL quitando el token
				window.history.replaceState({}, document.title, window.location.pathname);

				setTimeout(() => {
					onBack();

					// Redirigir a la URL base sin token
					//window.location.href = 'https://intelego.com.mx/tools';

				}, 2000);

			} else {
				const data = await response.json();
				setError(data.error || 'Error al actualizar la contraseña');
			}
		} catch (error) {
			setError('Error de conexión. Intenta más tarde.');
		} finally {
			setIsLoading(false);
		}
	};

	if (!tokenValid && !error) {
		return (
			<div className="login-background">
				<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 24 }}>
					<div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
						<img src={imgLogoFemsa} alt="FEMSA" style={{ height: 36 }} />
						<img src={imgLogoMirc} alt="MIRC" style={{ height: 30, borderLeft: '1px solid rgba(255,255,255,0.5)', paddingLeft: 16 }} />
					</div>
					<div className="login-form">
						<div style={{ textAlign: 'center' }}>
							<div className="spinner-border mb-3" role="status"></div>
							<div>Verificando enlace...</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	return (
		<div className="login-background">
			<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 24 }}>
				<div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
					<img src={imgLogoFemsa} alt="FEMSA" style={{ height: 36 }} />
					<img src={imgLogoMirc} alt="MIRC" style={{ height: 30, borderLeft: '1px solid rgba(255,255,255,0.5)', paddingLeft: 16 }} />
				</div>
				<div className="login-form">

				<h2 className="login-title">Restablecer Contraseña</h2>

				{userEmail && (
					<p style={{ textAlign: 'center', color: '#6c757d', marginBottom: '20px' }}>
						Para: {userEmail}
					</p>
				)}

				{error && (
					<div className="error-message">
						{error}
					</div>
				)}

				{message && (
					<div style={{
						color: '#28a745',
						backgroundColor: '#d4edda',
						border: '1px solid #c3e6cb',
						padding: '10px',
						borderRadius: '8px',
						marginBottom: '20px',
						textAlign: 'center'
					}}>
						{message}
					</div>
				)}

				{tokenValid && !message && (
					<form onSubmit={handleSubmit}>
						<div className="input-group">
							<div className="password-input-container">
								<input
									type={showPassword ? "text" : "password"}
									value={formData.password}
									onChange={(e) => setFormData({ ...formData, password: e.target.value })}
									className="form-control-login"
									placeholder="Nueva contraseña"
								/>
								<button
									type="button"
									onClick={() => setShowPassword(!showPassword)}
									className="password-toggle"
								>
									<FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
								</button>
							</div>
							{formData.password && (() => {
								const check = checkPassword(formData.password);
								const okColor = '#28a745';
								const badColor = '#dc3545';
								return (
									<div style={{ fontSize: '16px', color: '#6c757d', marginTop: '5px', textAlign: 'left' }}>
										<div>La contraseña debe tener:</div>
										<div style={{ color: check.meetsLength ? okColor : badColor }}>
											• Al menos {MIN_LENGTH_STANDARD} caracteres
										</div>
										<div style={{ color: check.meetsTypes ? okColor : badColor }}>
											• Al menos {REQUIRED_CHAR_TYPES} de estos 4 tipos ({check.typesCount}/4):
										</div>
										<div style={{ paddingLeft: 16, color: check.hasUpperCase ? okColor : badColor }}>
											– Una letra mayúscula
										</div>
										<div style={{ paddingLeft: 16, color: check.hasLowerCase ? okColor : badColor }}>
											– Una letra minúscula
										</div>
										<div style={{ paddingLeft: 16, color: check.hasNumber ? okColor : badColor }}>
											– Un número
										</div>
										<div style={{ paddingLeft: 16, color: check.hasSpecialChar ? okColor : badColor }}>
											– Un carácter especial o de puntuación
										</div>
									</div>
								);
							})()}

						</div>

						<div className="input-group">
							<div className="password-input-container">
								<input
									type={showConfirmPassword ? "text" : "password"}
									value={formData.confirmPassword}
									onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
									className="form-control-login"
									placeholder="Confirmar nueva contraseña"
								/>
								<button
									type="button"
									onClick={() => setShowConfirmPassword(!showConfirmPassword)}
									className="password-toggle"
								>
									<FontAwesomeIcon icon={showConfirmPassword ? faEyeSlash : faEye} />
								</button>
							</div>
							{formData.confirmPassword && formData.password !== formData.confirmPassword && (
								<div style={{ fontSize: '12px', color: '#dc3545', marginTop: '5px' }}>
									Las contraseñas no coinciden
								</div>
							)}

						</div>

						<button
							type="submit"
							className="btn-login"
							disabled={isLoading || !checkPassword(formData.password).isValid || formData.password !== formData.confirmPassword}
						>
							{isLoading ? 'Actualizando...' : 'Actualizar Contraseña'}
						</button>
					</form>
				)}

				<div style={{ textAlign: 'center', marginTop: '20px' }}>
					<button
						//onClick={() => navigate('/')}
						onClick={() => { window.history.replaceState({}, document.title, window.location.pathname); onBack(); }}
						style={{
							background: 'none',
							border: 'none',
							color: '#c0392b',
							textDecoration: 'none',
							cursor: 'pointer',
							fontSize: '16px',
							fontWeight: 700,
							display: 'block',
							textAlign: 'center',
							marginBottom: '16px',
							width: '100%'
						}}
					>
						Volver al inicio de sesión
					</button>
				</div>
			</div>
			</div>
		</div>
	);
};

export default ResetPassword;
